import styled from '@emotion/styled';

export const RoundedImage = styled.img<{ size: number }>`
  border-radius: 100%;
  width: ${(props) => `${props.size}px`};
  height: ${(props) => `${props.size}px`};
  object-fit: cover;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
`;
